import { isApiUrl, readTrackingId } from "~/utils/trackingId";

// One global interceptor rather than per-store edits, so no call site can miss the id. Scoped to
// apiBase so it never reaches a third party.
export default defineNuxtPlugin(() => {
  // Runs after mixpanel.client.ts, so the boot-time ?loginAs= consumption gets marked here.
  useTracking().syncStaffAssisted();

  const apiBase = useRuntimeConfig().public.apiBase as string;
  if (!apiBase) return;

  globalThis.$fetch = $fetch.create({
    onRequest({ request, options }) {
      const url = typeof request === "string" ? request : request.url;
      if (!isApiUrl(url, apiBase)) return;

      const trackingId = readTrackingId();
      if (!trackingId) return;

      // A query param the caller set itself wins.
      options.query = { tracking_id: trackingId, ...(options.query || {}) };
    },
  });
});
